import type { IconProps } from "./icon-types";

/**
 * 하단 막대 + 아래 화살표(arrow-down-to-line). "맨 아래로 스크롤"/끝으로 이동 등에서 사용
 * (제품 의미 부여는 소비 앱의 semantic alias 책임). 짝은 `ArrowUpToLineIcon`.
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). AngleDouble* 과 같은 24 그리드 / stroke 기반.
 */
export const ArrowDownToLineIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M5 21h14" />
    <path d="M12 3v14" />
    <path d="m6 11 6 6 6-6" />
  </svg>
);
